import React,{useState} from 'react'
import Menu from './menu'
//import './header.css'
import icon from '../icons.svg'; 
import icon_wifi from '../icon_wifi.svg'; 
import {load,loaddat,localestr} from '../utils.js'

//import ChangePass from './changePass';

let findDlg=false

function Header({User,status,actions,Rights,catDevices,printers,curr_printer,Tasks,wndType,catList=[],addGood,stoplist=[],timekeeping, otherSettings}){
    const [findText, setText] = useState('');
    const [findArr, setArr] = useState(null);
    const [timer, setTimer] = useState(null);

    const {tabsMode='0',soundMode='0'}=otherSettings||{}

    const logoff = () => {
        if(Tasks&&Tasks.length>0) {
            for(let i=0;i<Tasks.length;i++) actions.sendTask(Tasks[i].uid)
            setTimeout(()=>logoff(),300)
            return
        }
        load("action=logoff",actions.setLogin)
    }

    const loadStartData=()=>{
        loaddat("action=getStartData",(d)=>{actions.loadData(d,'startData')})
    }

    const tabsText= tabsMode === "1" ? localestr('Показати всі вкладки') : localestr('Сховати вкладки в меню');
    const soundText= soundMode === "1" ? localestr('Включити звук') : localestr('Вимкнути звук');
    const menuData=[
        {name:localestr('Вийти'),icon:'#log',action:logoff},
        //{name:localestr('Змінити пароль'),action:()=>{}},
        {name:localestr('Оновити дані'),icon:'#refr',action:loadStartData},
        //{name: tabsText,icon: "#b956",action: () => {actions.runCmd("setTabsMode", null)},},
        //{name: soundText,icon: "#speaker",action: () => {actions.runCmd("setSoundMode", null)},},
        {name:localestr('Звіти'),icon:'#repo',isFolder:true,id:1},
        {name:localestr('Виручка за сьогодні'),action:()=>{actions.runCmd('prnRep1')},parent:1},
        {name:localestr('Виручка за вчора'),action:()=>{actions.runCmd('prnRep2')},parent:1},
        {name:localestr('Продані товари'),action:()=>{actions.runCmd('prnRep4')},parent:1},
        {name:localestr('Реєстр чеків'),action:()=>{actions.runCmd('getOrderList')},parent:1},

    ]
    if(Rights.constXprs) menuData.push({name:localestr('Звіт по кур\'єрах'),action:()=>{actions.runCmd('prnRep3')},parent:1})

    if(Rights.urCashTransactions || Rights.urAdmin) {
        menuData.push({name:localestr('Касові операції'),icon:'#btn3',isFolder:true,id:5});
        if(Rights.urCashOpp0 || Rights.urAdmin) menuData.push({name:localestr('Отримання з іншої каси'),action:()=>{actions.runCmd('getTransfer')},parent:5});
        if(Rights.urCashOpp1 || Rights.urAdmin) menuData.push({name:localestr('Передача до іншої каси'),action:()=>{actions.runCmd('addTransfer')},parent:5});
        if(Rights.urCashOpp2 || Rights.urAdmin) menuData.push({name:localestr('Оплата постачальнику'),action:()=>{actions.runCmd('addSupplierPayment')},parent:5});
        if(Rights.urCashOpp3 || Rights.urAdmin) menuData.push({name:localestr('Інші видатки'),action:()=>{actions.runCmd('addOtherExpense')},parent:5});
        if(Rights.urCashOpp4 || Rights.urAdmin) menuData.push({name:localestr('Інші поступлення'),action:()=>{actions.runCmd('addOtherAdmission')},parent:5});
        // {name:localestr('Видача сертифікату'),action:()=>{actions.runCmd('addCertificate')},parent:5});
        if(Rights.urCashRep || Rights.urAdmin) menuData.push({name:localestr('Звіт по касі'),action:()=>{actions.runCmd('prnRep5')},parent:5})
    }

    if(Rights.urFiscal || Rights.urAdmin) {
        if(catDevices&&catDevices.length){
            menuData.push({name:localestr('Програмний РРО'),icon:'#rro',isFolder:true,id:2})
            catDevices.forEach(el => {
                menuData.push({name:el.name,action:()=>{actions.runCmd('showRRO',el)},parent:2})
            })
            //console.log(Rights)
        }
    }

    menuData.push({name:localestr('Налаштування'),icon:'#b402',isFolder:true,id:9})
    menuData.push({name: tabsText,icon: "#b956",action: () => {actions.runCmd("setTabsMode", null)},parent:9})
    menuData.push({name: soundText,icon: "#speaker",action: () => {actions.runCmd("setSoundMode", null)},parent:9})

    if(Rights.urAdmin) {
        if(!timekeeping){
            menuData.push({name:localestr('Дозволити табелювання'),icon:'#btn15',action:()=>{actions.setTimekeeping(1)},parent:9})
        } else {
            menuData.push({name:localestr('Заборонити табелювання'),icon:'#btn15',action:()=>{actions.setTimekeeping(0)},parent:9})
        }
    }

    if(curr_printer){
        menuData.push({name:localestr('Чековий принтер'),icon:'#b503',isFolder:true,id:3})
        menuData.push({name:curr_printer.name,action:()=>{},parent:3})
        menuData.push({name:localestr('Вибрати інший'),action:()=>actions.runCmd('chnPrinter',null),parent:3})
    } else if(printers) {
        menuData.push({name:localestr('Вибрати принтер'),icon:'#b503',action:()=>actions.runCmd('chnPrinter',null)})
    }

    menuData.push({name:localestr('Вибір теми'),icon:'#thm',isFolder:true,id:4})
    menuData.push({name:'м\'ятна',icon:'#thm1',action:()=>{actions.runCmd('chnTheme','1')},parent:4})
    menuData.push({name:'Бузкова',icon:'#thm2',action:()=>{actions.runCmd('chnTheme','2')},parent:4})
    //menuData.push({name:'Темна',icon:'#thm2',action:()=>{actions.runCmd('chnTheme','3')},parent:4})

    // new themes
    menuData.push({name: "Коктель Шеф",icon: "#thm_0",action: () => {actions.runCmd("chnTheme", "00");},parent: 4,});
    menuData.push({name: "Pewter Blue",icon: "#thm_2",action: () => {actions.runCmd("chnTheme", "02");},parent: 4,});
    menuData.push({name: "Smoke Lavender",icon: "#thm_3",action: () => {actions.runCmd("chnTheme", "03");},parent: 4,});
    
    
    let ofl=''
    if(status==='OffLine') ofl=<div className='toolBarIcon'><img className='toolBarImg' src={icon_wifi+'#wifi'} alt='' /></div>

    let btnExt=null
    if((window.innerWidth>window.innerHeight&&window.innerWidth>900)){
        btnExt=<div className='toolBarItem' style={{border:'none',background:'none',paddingRight:'8px'}}><div className='navbarExt' onClick={logoff}></div></div>
    }

    const findItem=(val)=>{
        //const newData={...wndData,findText:val}
        findDlg=false
        //newData.findArr=null
        if (val.length>1){
            let Arr=catList.filter(el=>(el.id.indexOf(val)===0||(el.name||'').toLowerCase().indexOf(val.toLowerCase())!==-1||(el.barcode&&el.barcode.indexOf(val)===0))&&!parseInt(el.marked))
            Arr=Arr.filter(el=>!stoplist.find(e=>e.good===el.id&&e.qtt<=0))
            if(Arr.length>10) Arr.splice(10)
            if(Arr.length){
                findDlg=true
                setArr(Arr)
                if(timer) clearTimeout(timer)
                setTimer(setTimeout(()=>findDlg=false,30000))
            }
            else{
                setArr(null)
                findDlg=false
                setTimer(null)
            }
        }
        setText(val)
        //setWndData(newData)
    }


    const findClick=(el)=>{
        //const newData={...wndData,currentCol:el,currentFld:el.parent,findText:'',findArr:null}
        findDlg=false
        setText('')
        if(addGood) addGood(el)
        //setWndData(newData)
    }


    let ord_cont=null
    if(wndType==='orderTab'){
        let findItems=null
        if(findDlg&&findArr){
            const items=findArr.map((el,idx)=>{
                let stl={cursor:'pointer',fontSize:'small',lineHeight:'28px',textWrap:'nowrap',display:'flex',margin:'2px'}
                return(
                <div key={idx} style={stl} onClick={()=>{findClick(el)}}><div style={{width:'80%',textAlign:'left',overflow:'hidden'}}>{el.name}</div><div style={{width:'20%',textAlign:'right',overflow:'hidden'}}>{el.price}</div></div>
            )})
            findItems=<div className='no-print' style={{right:'0px',top:'30px',width:'100%',position:'absolute',background:'#FFFFFF',zIndex:'100'}}>
                {items}
            </div>
        }
        ord_cont=<div style={{position:'relative',padding:'3px',flexGrow:'10',width:'150px',maxWidth:'200px',color:'var(--black-tx-color)',fontSize:'medium'}}>
        <input type='text' value={findText} onChange={(e)=>{findItem(e.target.value)}} onBlur={()=>{setTimeout(()=>setArr(null),200)}} placeholder={localestr('пошук')} 
            style={{width:'calc(100% - 28px)',padding:'0 22px 0 8px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit',height:'26px',borderRadius:'14px',border:'1px solid var(--dark-tx-color)'}} />
        <img src={icon+'#b956'} alt='' style={{position:'absolute',right:'6px',top:'10px',width:'14px',height:'14px',opacity:0.5}}/>
        {findItems}
    </div>

    }

    return (
    <header className='navbar no-print'>
        {/*<div className='logo'></div>*/}<div className='label' style={{marginRight:'5%'}}></div>
        {ord_cont}
    <div style={{verticalAlign:'middle',flexGrow:'10',textWrap:'nowrap'}}>{User}</div>
    {ofl}{btnExt}
    <div className='toolBarItem' style={{border:'none',background:'none'}}><Menu data={menuData}>
    {/*<img className='toolBarImg' src={icon+'#menu'} alt='' />*/}
    <div className='navbarMenu'></div>
    </Menu></div>
    </header>

)
}

export default Header